
//const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const logos = state => state.logos;
const getsingle = state => param =>state.logos.find((a)=> a.id == param)

export default {
  //formdata,
  data,
  dataobject,
  logos,
  getsingle
};